import styled from 'styled-components';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const StyledMobileBoxItem = styled.div`
  border: 1px solid #dadce0;
  margin-bottom: 15px;
  padding: 10px;
  padding-bottom: 15px;
  font-size: 14px;
  position: relative;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const StyledMobileBoxItemRow = styled.div`
  margin-bottom: 15px;
  font-weight: 600;
  max-width: 60%;
  word-break: break-word;
  span {
    font-weight: 400;
  }
`;

export const StyledMobileBoxLabel = styled.div`
  font-size: 14px;
  position: absolute;
  right: 10px;
  top: 10px;
  color: #cccccc;
  max-width: 35%;
  word-break: break-word;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const StyledMobileBoxSelectableItem = styled(StyledMobileBoxItemRow)`
     div {
        font-weight: 400;
     }
     
     span {
        font-weight: 600;
        display: block
        margin-bottom: 5px;
     }
`;
